import { createRoot } from "react-dom/client";
import { WorkflowGrid } from "../../workflow_grid";
import { OPERATIONS_COLUMNS } from "../../workflow_grid/columns";

export const initOperationsGrid = () => {
  const workContainer = document.getElementById("work-queue");

  if (workContainer) {
    const root = createRoot(workContainer);

    const {
      defaultAssignee,
      assignmentUrl,
      bulkCloseUrl,
      bulkEscalateUrl,
      canEscalate,
      canAssign,
      initialFilterOptions,
      uiEnabledColumns: columns,
      preprocessingCategories: categories,
      assignableUsers,
    } = workContainer.dataset;

    const parsedCanAssign = canAssign === "true";
    const parsedAssignableUsers = assignableUsers ? JSON.parse(assignableUsers) : null;

    const uiEnabledColumns = columns ? JSON.parse(columns) : null;
    const preprocessingCategories = categories ? JSON.parse(categories) : null;

    let { lab: initialLabOptions, payor: initialPayorOptions } = JSON.parse(initialFilterOptions);
    initialLabOptions = initialLabOptions || [];
    initialPayorOptions = initialPayorOptions || [];

    const filterOptions = {
      assignableUsers: parsedAssignableUsers,
      initialLabOptions,
      initialPayorOptions,
    };

    const prefilledColumns = uiEnabledColumns?.filter((column) => column.prefilled_value);
    const parsedPrefilledColumns = prefilledColumns?.map((column) => ({ id: column.column_name, value: column.prefilled_value }));

    root.render(
      <WorkflowGrid
        apiUrl="/cases.json"
        canAssign={parsedCanAssign}
        bulkCloseUrl={bulkCloseUrl}
        bulkEscalateUrl={bulkEscalateUrl}
        canEscalate={canEscalate}
        assignmentUrl={assignmentUrl}
        defaultFilters={parsedPrefilledColumns}
        filterOptions={filterOptions}
        columns={OPERATIONS_COLUMNS(uiEnabledColumns, parsedPrefilledColumns)}
        preprocessingCategories={preprocessingCategories}
      />
    );
  }
};
